"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.66 15.992H2.879c-.41 0-.73-.304-.73-.692V1.602h1v13.39h10.01V1.02H4.127v-1h9.315a.72.72 0 0 1 .719.72v14.753a.5.5 0 0 1-.5.5ZM4.18 4.406h8v-1h-8v1Zm8 3.009h-8v-1h8v1Zm-8 3.009h8v-1h-8v1ZM2.149 1.602h1V.028h-.28a.72.72 0 0 0-.72.72v.854Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m20.492 23.983-16.547-.006c-.515 0-.919-.374-.919-.852V.934c0-.495.403-.897.897-.897h.228v22.815l15.779.006V1.162H5.846V.037H20.08c.259 0 .528.112.718.302a.835.835 0 0 1 .257.594V23.42a.563.563 0 0 1-.563.563ZM5.931 6.323h12.221V5.198H5.931v1.125Zm0 4.597h12.221V9.795H5.931v1.125Zm12.221 4.598H5.931v-1.126h12.221v1.126Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M27.323 31.977 5.26 31.97c-.687 0-1.225-.5-1.225-1.136V1.245c0-.66.537-1.196 1.196-1.196h.304V30.47l21.038.007V1.549H7.794v-1.5h18.979c.345 0 .704.15.957.403.222.22.343.5.343.792v29.983a.75.75 0 0 1-.75.75ZM7.908 8.43h16.295v-1.5H7.908v1.5Zm0 6.13h16.295v-1.5H7.908v1.5Zm16.295 6.13H7.908v-1.5h16.295v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M42 47.93H8.764c-.95 0-1.612-.92-1.612-1.744V4.371l-.009-2.633c0-.893.727-1.62 1.62-1.62h.272L9.026 2.01h.009l-.009 2.362v41.684h32.036V1.975H12.64V.1h28.686c.89 0 1.612.723 1.612 1.612v45.28a.939.939 0 0 1-.937.938ZM12.808 12.405h24.637V10.53H12.808v1.875Zm24.637 9.267H12.808v-1.875h24.637v1.875ZM12.808 30.94h24.637v-1.875H12.808v1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M56 63.906H11.686c-1.268 0-2.15-1.226-2.15-2.325V5.83l-.012-3.511c0-1.191.97-2.16 2.161-2.16h.361l-.01 2.52h.01l-.01 3.15v55.578H54.75V2.633H16.852v-2.5H55.1c1.186 0 2.15.964 2.15 2.15v60.373a1.252 1.252 0 0 1-1.25 1.25ZM17.078 16.54h32.849v-2.5H17.078v2.5Zm32.849 12.356H17.078v-2.5h32.849v2.5ZM17.078 41.254h32.849v-2.5H17.078v2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDocument = function IconDocument(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Document' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Document"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDocument.sizes = [16, 24, 32, 48, 64];
IconDocument.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDocument;
exports.default = _default;